export const getRect = el => (el ? el.getBoundingClientRect() : {});

export const offset = el => {
    var rect = getRect(el),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
};

export const myTopAboveViewTop = el => el.getBoundingClientRect().top <= 0;

// true when el top is above the bottom of the viewport
export const myTopAboveViewBottom = el => {
    let topToBottomOffset = window.innerHeight - getRect(el).top;
    return topToBottomOffset > 0;
};

// true when el bottom is below the top of the viewport
export const myBottomBelowViewTop = el => {
    return getRect(el).bottom >= 0;
};

export const myBottomAboveViewBottom = el => el.getBoundingClientRect().bottom <= window.innerHeight;

// 0 - 100 starting when top enters viewport and ends when bottom goes past the top of viewport
export const percentThroughView = el => {
    let scrollPos = window.scrollY;
    let top = offset(el).top - window.innerHeight;
    let bottom = top + el.getBoundingClientRect().height + window.innerHeight;
    let range = bottom - top;
    let percent = (scrollPos - top) / range;
    return percent;
};

// 0 - 100, progress of the top through the viewport
export const topThroughView = el => {
    let rect = getRect(el);
    return (window.innerHeight - rect.top) / window.innerHeight;
};

// True when the top of el is above the bottom of the viewport and the bottom of el is below the top of viewport
export const inView = el => myTopAboveViewBottom(el) && myBottomBelowViewTop(el);

export const getTopScrollPos = el => (window.innerHeight - getRect(el).top) / window.innerHeight;

export const getPercentLocOfView = (loc = 0.5) => window.innerHeight * loc;
